// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const microcopyResponseSchema = z.object({
  "product_name": z.string(),
  "primary_method_label": z.string(),
  "backup_label": z.string(),
  "support_handle": z.string(),
  "support_help_url": z.string(),
  "pureid_qr_card_title": z.string(),
  "updated_at": z.string().datetime({ offset: true }).optional()
});
